import { createChangeString } from '../flexUtils';
import type { Manifest, ChangeDefinitionInCreation } from '@sap/ux-specification-types';

/**
 * Exports a change definition to a flex change string.
 *
 * @param change - The change definition to be exported.
 * @param manifest - The manifest containing metadata for the change.
 * @returns The serialized flex change string.
 */
export function exportToFlexChange(change: ChangeDefinitionInCreation, manifest: Manifest): string {
    return createChangeString(change, manifest);
}
